import { createContext, useContext, useMemo } from 'react';

import { useLoadingState } from '@gitbook/util-react-hooks';
import { assert } from '@gitbook/util-ts';

const SiteLoadingContext = createContext<{
    isLoading: boolean;
    wrapLoading: (fn: () => Promise<void>) => Promise<void>;
} | null>(null);

/**
 * Shared loading state for the site screen.
 */
export function SiteLoadingProvider(props: { children: React.ReactNode }) {
    const [isLoading, wrapLoading] = useLoadingState(false);

    const value = useMemo(() => ({ isLoading, wrapLoading }), [isLoading, wrapLoading]);

    return (
        <SiteLoadingContext.Provider value={value}>{props.children}</SiteLoadingContext.Provider>
    );
}

export function useSiteScreenLoading() {
    const context = useContext(SiteLoadingContext);
    assert(context, 'useSiteScreenLoading must be used within a SiteLoadingProvider');
    return context;
}
